import React from 'react'

const PopularIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16'>
      <g fill='#DA234E' fillRule='nonzero'>
        <path d='M10.195 11.651c0-.875-.605-2.071-1.7-3.368a.64.64 0 0 0-.496-.227.656.656 0 0 0-.501.228c-1.2 1.399-1.786 2.636-1.684 3.584.08.606.418 1.15.927 1.492.356.29.798.458 1.258.478a2.193 2.193 0 0 0 2.196-2.187z' />
        <path d='M10.712 2.691c-.46-.39-.944-.798-1.437-1.244a1.736 1.736 0 0 0-1.394-.432 1.67 1.67 0 0 0-1.19.759 11.867 11.867 0 0 0-1.462 3.763 3.634 3.634 0 0 1-.279-.476 1.175 1.175 0 0 0-1.935-.276A5.28 5.28 0 0 0 1.5 8.532a6.412 6.412 0 0 0 4.82 6.263A6.86 6.86 0 0 0 7.947 15a3.264 3.264 0 0 1-1.922-.715 3.284 3.284 0 0 1-1.377-2.296c-.135-1.29.523-2.791 1.957-4.463.348-.406.857-.64 1.394-.638h.006a1.82 1.82 0 0 1 1.387.642c.901 1.067 1.977 2.647 1.977 4.12a3.361 3.361 0 0 1-3.142 3.343c3.5-.112 6.278-2.971 6.273-6.457-.003-2.644-1.757-4.126-3.788-5.845z' />
      </g>
    </svg>
  )
}

export default PopularIcon
